export const MuiTypography = {
  defaultProps: {
    variantMapping: {
      'display-hero': 'h1',
      'display-h1': 'h1',
      'display-h2': 'h2',
      'display-h3': 'h3',
      'display-h4': 'h4',
    },
  },
}
